import React from 'react';
import TestimonialContent from './testimonial/TestimonialContent';
import TestimonialFooter from './testimonial/TestimonialFooter';
import RatingBar from "../../../scenes/public/components/RatingBar";

interface TestimonialProps {
  name: string;
  role?: string;
  company?: string;
  rating: number
  eventTitle: string
  content: string
}

export default function Testimonial({
  name, role, company, eventTitle, rating, content
}: TestimonialProps) {

  return (
    <div className="mb-8 mt-4 antialiased">
      <div id="testimonial" className="">
        <div className="rounded-2xl border border-gray bg-white p-6 flex flex-col relative z-0">
          <RatingBar rating={rating} className="absolute -top-4 right-1 pl-2 rounded-xl h-8 bg-white text-xl md:text-2xl mb-1 z-0"/>
          <TestimonialContent content={content}/>
          <TestimonialFooter name={name} role={role} company={company} eventTitle={eventTitle}/>
        </div>
      </div>
    </div>
  );
}
